var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisibileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 869.24 929.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 926.68,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 884.63,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 845.07,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 807.87,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 772.87,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 739.95,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 708.99,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 679.86,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 652.46,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 626.69,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 602.44,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 579.64,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 558.19,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 538,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 519.01,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 501.14,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 484.32,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 468.49,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 453.59,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 439.55,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 426.33,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 413.87,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 402.12,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 391.04,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 380.58,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 370.71,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 361.37,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 352.55,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 344.18,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 336.26,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 328.74,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 321.6,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 314.8,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 308.33,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 302.15,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 296.25,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 290.6,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 285.18,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 279.97,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 274.96,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 270.12,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 265.45,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 260.92,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 256.51,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 252.23,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 248.04,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 243.95,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 239.94,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 235.99,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 232.1,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 228.26,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 224.47,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 220.71,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 216.97,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 213.24,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 209.54,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 205.83,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 202.13,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 198.42,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 194.7,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 190.97,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 187.22,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 183.46,
    width: 868.98,
    height: 3.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.26,5.78V0h71.78v5.78H.26ZM.26,13.05v-5.78h71.78v5.78H.26ZM.26,123.24v-5.78h71.78v5.78H.26ZM.26,130.51v-5.78h71.78v5.78H.26ZM29.53,20.51v-5.78h13.24v5.78h-13.24ZM29.53,27.78v-5.78h13.24v5.78h-13.24ZM29.53,35.05v-5.78h13.24v5.78h-13.24ZM29.53,42.51v-5.78h13.24v5.78h-13.24ZM29.53,49.78v-5.78h13.24v5.78h-13.24ZM29.53,57.05v-5.78h13.24v5.78h-13.24ZM29.53,64.51v-5.78h13.24v5.78h-13.24ZM29.53,71.78v-5.78h13.24v5.78h-13.24ZM29.53,79.24v-5.78h13.24v5.78h-13.24ZM29.53,86.51v-5.78h13.24v5.78h-13.24ZM29.53,93.78v-5.78h13.24v5.78h-13.24ZM29.53,101.24v-5.78h13.24v5.78h-13.24ZM29.53,108.51v-5.78h13.24v5.78h-13.24ZM29.53,115.78v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.82,5.78V0h13.05v5.78h-13.05ZM88.82,13.05v-5.78h13.05v5.78h-13.05ZM88.82,20.51v-5.78h27.78v5.78h-27.78ZM88.82,27.78v-5.78h27.78v5.78h-27.78ZM88.82,35.05v-5.78h13.05v5.78h-13.05ZM88.82,42.51v-5.78h13.05v5.78h-13.05ZM88.82,49.78v-5.78h13.05v5.78h-13.05ZM88.82,57.05v-5.78h13.05v5.78h-13.05ZM88.82,64.51v-5.78h13.05v5.78h-13.05ZM88.82,71.78v-5.78h13.05v5.78h-13.05ZM88.82,79.24v-5.78h13.05v5.78h-13.05ZM88.82,86.51v-5.78h13.05v5.78h-13.05ZM88.82,93.78v-5.78h13.05v5.78h-13.05ZM88.82,101.24v-5.78h13.05v5.78h-13.05ZM88.82,108.51v-5.78h13.05v5.78h-13.05ZM88.82,115.78v-5.78h13.05v5.78h-13.05ZM88.82,123.24v-5.78h13.05v5.78h-13.05ZM88.82,130.51v-5.78h13.05v5.78h-13.05ZM118.09,35.05v-5.78h13.05v5.78h-13.05ZM118.09,42.51v-5.78h13.05v5.78h-13.05ZM132.82,49.78v-5.78h27.78v5.78h-27.78ZM132.82,57.05v-5.78h27.78v5.78h-27.78ZM147.55,5.78V0h13.05v5.78h-13.05ZM147.55,13.05v-5.78h13.05v5.78h-13.05ZM147.55,20.51v-5.78h13.05v5.78h-13.05ZM147.55,27.78v-5.78h13.05v5.78h-13.05ZM147.55,35.05v-5.78h13.05v5.78h-13.05ZM147.55,42.51v-5.78h13.05v5.78h-13.05ZM147.55,64.51v-5.78h13.05v5.78h-13.05ZM147.55,71.78v-5.78h13.05v5.78h-13.05ZM147.55,79.24v-5.78h13.05v5.78h-13.05ZM147.55,86.51v-5.78h13.05v5.78h-13.05ZM147.55,93.78v-5.78h13.05v5.78h-13.05ZM147.55,101.24v-5.78h13.05v5.78h-13.05ZM147.55,108.51v-5.78h13.05v5.78h-13.05ZM147.55,115.78v-5.78h13.05v5.78h-13.05ZM147.55,123.24v-5.78h13.05v5.78h-13.05ZM147.55,130.51v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.38,5.78V0h13.05v5.78h-13.05ZM177.38,13.05v-5.78h13.05v5.78h-13.05ZM177.38,20.51v-5.78h13.05v5.78h-13.05ZM177.38,27.78v-5.78h13.05v5.78h-13.05ZM177.38,35.05v-5.78h13.05v5.78h-13.05ZM177.38,42.51v-5.78h13.05v5.78h-13.05ZM177.38,49.78v-5.78h13.05v5.78h-13.05ZM177.38,57.05v-5.78h13.05v5.78h-13.05ZM177.38,64.51v-5.78h13.05v5.78h-13.05ZM177.38,71.78v-5.78h13.05v5.78h-13.05ZM177.38,79.24v-5.78h13.05v5.78h-13.05ZM177.38,86.51v-5.78h13.05v5.78h-13.05ZM177.38,93.78v-5.78h13.05v5.78h-13.05ZM177.38,101.24v-5.78h13.05v5.78h-13.05ZM192.11,108.51v-5.78h13.05v5.78h-13.05ZM192.11,115.78v-5.78h13.05v5.78h-13.05ZM206.65,123.24v-5.78h13.24v5.78h-13.24ZM206.65,130.51v-5.78h13.24v5.78h-13.24ZM221.38,108.51v-5.78h13.05v5.78h-13.05ZM221.38,115.78v-5.78h13.05v5.78h-13.05ZM236.11,5.78V0h13.05v5.78h-13.05ZM236.11,13.05v-5.78h13.05v5.78h-13.05ZM236.11,20.51v-5.78h13.05v5.78h-13.05ZM236.11,27.78v-5.78h13.05v5.78h-13.05ZM236.11,35.05v-5.78h13.05v5.78h-13.05ZM236.11,42.51v-5.78h13.05v5.78h-13.05ZM236.11,49.78v-5.78h13.05v5.78h-13.05ZM236.11,57.05v-5.78h13.05v5.78h-13.05ZM236.11,64.51v-5.78h13.05v5.78h-13.05ZM236.11,71.78v-5.78h13.05v5.78h-13.05ZM236.11,79.24v-5.78h13.05v5.78h-13.05ZM236.11,86.51v-5.78h13.05v5.78h-13.05ZM236.11,93.78v-5.78h13.05v5.78h-13.05ZM236.11,101.24v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.93,5.78V0h71.78v5.78h-71.78ZM265.93,13.05v-5.78h71.78v5.78h-71.78ZM265.93,123.24v-5.78h71.78v5.78h-71.78ZM265.93,130.51v-5.78h71.78v5.78h-71.78ZM295.2,20.51v-5.78h13.24v5.78h-13.24ZM295.2,27.78v-5.78h13.24v5.78h-13.24ZM295.2,35.05v-5.78h13.24v5.78h-13.24ZM295.2,42.51v-5.78h13.24v5.78h-13.24ZM295.2,49.78v-5.78h13.24v5.78h-13.24ZM295.2,57.05v-5.78h13.24v5.78h-13.24ZM295.2,64.51v-5.78h13.24v5.78h-13.24ZM295.2,71.78v-5.78h13.24v5.78h-13.24ZM295.2,79.24v-5.78h13.24v5.78h-13.24ZM295.2,86.51v-5.78h13.24v5.78h-13.24ZM295.2,93.78v-5.78h13.24v5.78h-13.24ZM295.2,101.24v-5.78h13.24v5.78h-13.24ZM295.2,108.51v-5.78h13.24v5.78h-13.24ZM295.2,115.78v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.49,20.51v-5.78h13.05v5.78h-13.05ZM354.49,27.78v-5.78h13.05v5.78h-13.05ZM354.49,35.05v-5.78h13.05v5.78h-13.05ZM354.49,42.51v-5.78h13.05v5.78h-13.05ZM354.49,108.51v-5.78h13.05v5.78h-13.05ZM354.49,115.78v-5.78h13.05v5.78h-13.05ZM369.03,5.78V0h42.51v5.78h-42.51ZM369.03,13.05v-5.78h42.51v5.78h-42.51ZM369.03,49.78v-5.78h13.24v5.78h-13.24ZM369.03,57.05v-5.78h13.24v5.78h-13.24ZM369.03,123.24v-5.78h42.51v5.78h-42.51ZM369.03,130.51v-5.78h42.51v5.78h-42.51ZM383.76,64.51v-5.78h13.24v5.78h-13.24ZM383.76,71.78v-5.78h13.24v5.78h-13.24ZM398.49,79.24v-5.78h13.05v5.78h-13.05ZM398.49,86.51v-5.78h13.05v5.78h-13.05ZM413.22,20.51v-5.78h13.05v5.78h-13.05ZM413.22,27.78v-5.78h13.05v5.78h-13.05ZM413.22,93.78v-5.78h13.05v5.78h-13.05ZM413.22,101.24v-5.78h13.05v5.78h-13.05ZM413.22,108.51v-5.78h13.05v5.78h-13.05ZM413.22,115.78v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.05,5.78V0h71.78v5.78h-71.78ZM443.05,13.05v-5.78h71.78v5.78h-71.78ZM443.05,123.24v-5.78h71.78v5.78h-71.78ZM443.05,130.51v-5.78h71.78v5.78h-71.78ZM472.32,20.51v-5.78h13.24v5.78h-13.24ZM472.32,27.78v-5.78h13.24v5.78h-13.24ZM472.32,35.05v-5.78h13.24v5.78h-13.24ZM472.32,42.51v-5.78h13.24v5.78h-13.24ZM472.32,49.78v-5.78h13.24v5.78h-13.24ZM472.32,57.05v-5.78h13.24v5.78h-13.24ZM472.32,64.51v-5.78h13.24v5.78h-13.24ZM472.32,71.78v-5.78h13.24v5.78h-13.24ZM472.32,79.24v-5.78h13.24v5.78h-13.24ZM472.32,86.51v-5.78h13.24v5.78h-13.24ZM472.32,93.78v-5.78h13.24v5.78h-13.24ZM472.32,101.24v-5.78h13.24v5.78h-13.24ZM472.32,108.51v-5.78h13.24v5.78h-13.24ZM472.32,115.78v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.6,0h57.05v5.78h-57.05V0ZM531.6,7.27h57.05v5.78h-57.05v-5.78ZM544.66,14.73v5.78h-13.05v-5.78h13.05ZM544.66,22v5.78h-13.05v-5.78h13.05ZM544.66,29.27v5.78h-13.05v-5.78h13.05ZM544.66,36.73v5.78h-13.05v-5.78h13.05ZM544.66,44v5.78h-13.05v-5.78h13.05ZM544.66,51.27v5.78h-13.05v-5.78h13.05ZM531.6,58.73h57.05v5.78h-57.05v-5.78ZM531.6,66h57.05v5.78h-57.05v-5.78ZM544.66,73.46v5.78h-13.05v-5.78h13.05ZM544.66,80.73v5.78h-13.05v-5.78h13.05ZM544.66,88v5.78h-13.05v-5.78h13.05ZM544.66,95.46v5.78h-13.05v-5.78h13.05ZM544.66,102.73v5.78h-13.05v-5.78h13.05ZM544.66,110v5.78h-13.05v-5.78h13.05ZM531.6,117.46h57.05v5.78h-57.05v-5.78ZM531.6,124.73h57.05v5.78h-57.05v-5.78ZM590.33,14.73h13.05v5.78h-13.05v-5.78ZM590.33,27.78v-5.78h13.05v5.78h-13.05ZM590.33,35.05v-5.78h13.05v5.78h-13.05ZM590.33,42.51v-5.78h13.05v5.78h-13.05ZM590.33,49.78v-5.78h13.05v5.78h-13.05ZM590.33,57.05v-5.78h13.05v5.78h-13.05ZM590.33,79.24v-5.78h13.05v5.78h-13.05ZM590.33,86.51v-5.78h13.05v5.78h-13.05ZM590.33,93.78v-5.78h13.05v5.78h-13.05ZM590.33,101.24v-5.78h13.05v5.78h-13.05ZM590.33,108.51v-5.78h13.05v5.78h-13.05ZM590.33,115.78v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.16,5.78V0h71.78v5.78h-71.78ZM620.16,13.05v-5.78h71.78v5.78h-71.78ZM620.16,123.24v-5.78h71.78v5.78h-71.78ZM620.16,130.51v-5.78h71.78v5.78h-71.78ZM649.43,20.51v-5.78h13.24v5.78h-13.24ZM649.43,27.78v-5.78h13.24v5.78h-13.24ZM649.43,35.05v-5.78h13.24v5.78h-13.24ZM649.43,42.51v-5.78h13.24v5.78h-13.24ZM649.43,49.78v-5.78h13.24v5.78h-13.24ZM649.43,57.05v-5.78h13.24v5.78h-13.24ZM649.43,64.51v-5.78h13.24v5.78h-13.24ZM649.43,71.78v-5.78h13.24v5.78h-13.24ZM649.43,79.24v-5.78h13.24v5.78h-13.24ZM649.43,86.51v-5.78h13.24v5.78h-13.24ZM649.43,93.78v-5.78h13.24v5.78h-13.24ZM649.43,101.24v-5.78h13.24v5.78h-13.24ZM649.43,108.51v-5.78h13.24v5.78h-13.24ZM649.43,115.78v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M708.72,5.78V0h13.05v5.78h-13.05ZM708.72,13.05v-5.78h13.05v5.78h-13.05ZM708.72,20.51v-5.78h13.05v5.78h-13.05ZM708.72,27.78v-5.78h13.05v5.78h-13.05ZM708.72,35.05v-5.78h13.05v5.78h-13.05ZM708.72,42.51v-5.78h13.05v5.78h-13.05ZM708.72,49.78v-5.78h13.05v5.78h-13.05ZM708.72,57.05v-5.78h13.05v5.78h-13.05ZM708.72,64.51v-5.78h13.05v5.78h-13.05ZM708.72,71.78v-5.78h13.05v5.78h-13.05ZM708.72,79.24v-5.78h13.05v5.78h-13.05ZM708.72,86.51v-5.78h13.05v5.78h-13.05ZM708.72,93.78v-5.78h13.05v5.78h-13.05ZM708.72,101.24v-5.78h13.05v5.78h-13.05ZM708.72,108.51v-5.78h13.05v5.78h-13.05ZM708.72,115.78v-5.78h13.05v5.78h-13.05ZM708.72,123.24v-5.78h71.78v5.78h-71.78ZM708.72,130.51v-5.78h71.78v5.78h-71.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M797.27,5.78V0h71.97v5.78h-71.97ZM797.27,13.05v-5.78h71.97v5.78h-71.97ZM797.27,20.51v-5.78h13.24v5.78h-13.24ZM797.27,27.78v-5.78h13.24v5.78h-13.24ZM797.27,35.05v-5.78h13.24v5.78h-13.24ZM797.27,42.51v-5.78h13.24v5.78h-13.24ZM797.27,49.78v-5.78h13.24v5.78h-13.24ZM797.27,57.05v-5.78h13.24v5.78h-13.24ZM797.27,64.51v-5.78h60.22v5.78h-60.22ZM797.27,71.78v-5.78h60.22v5.78h-60.22ZM797.27,79.24v-5.78h13.24v5.78h-13.24ZM797.27,86.51v-5.78h13.24v5.78h-13.24ZM797.27,93.78v-5.78h13.24v5.78h-13.24ZM797.27,101.24v-5.78h13.24v5.78h-13.24ZM797.27,108.51v-5.78h13.24v5.78h-13.24ZM797.27,115.78v-5.78h13.24v5.78h-13.24ZM797.27,123.24v-5.78h71.97v5.78h-71.97ZM797.27,130.51v-5.78h71.97v5.78h-71.97Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibileWhite);
export default __webpack_public_path__ + "static/media/Invisibile_white.06799228c356319b61c8b7a5b1b343bb.svg";
export { ForwardRef as ReactComponent };